import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
const _excluded = ["children", "className", "title", "renderActions", "disableDivider", "style", "onClose", "showEscapeLabel"];
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from '@adsk/alloy-react-close-button';
import Divider from '@adsk/alloy-react-divider';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Header = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      className,
      title,
      renderActions,
      disableDivider = false,
      style,
      onClose,
      showEscapeLabel
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [style]
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing.M
    }]
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [{
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    }, theme.typography.heading2]
  }, title, renderActions === null || renderActions === void 0 ? void 0 : renderActions()), /*#__PURE__*/React.createElement(CloseButton, {
    "data-testid": "Panel__headerClose",
    onClick: onClose,
    showEscapeLabel: showEscapeLabel
  })), children, !disableDivider && /*#__PURE__*/React.createElement(Divider, null));
});
Header.displayName = 'Header';
Header.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Header content */
  children: PropTypes.any,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Title to display in header */
  title: PropTypes.any,
  /** Render header actions */
  renderActions: PropTypes.func,
  /** Disable the Divider below the header.  Defaults to false */
  disableDivider: PropTypes.bool,
  /** Function executed upon clicking close button */
  onClose: PropTypes.func
};
export default Header;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div").withConfig({
  displayName: "Header___StyledDiv3",
  componentId: "sc-qvq0ry-0"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=Header.js.map